export const raceOptions = [
  {
    raceId: '1',
    race: 'I',
    raceTitle: 'American Indian or Alaskan Native',
  },
  {
    raceId: '2',
    race: 'F',
    raceTitle: 'Asian Pacific American',
  },
  {
    raceId: '3',
    race: 'A',
    raceTitle: 'Asian or Pacific Islander',
  },
  {
    raceId: '4',
    race: 'B',
    raceTitle: 'Black',
  },
  {
    raceId: '5',
    race: 'N',
    raceTitle: 'Black (Non-Hispanic)',
  },
  {
    raceId: '6',
    race: 'C',
    raceTitle: 'Caucasian',
  },
  {
    raceId: '7',
    race: 'H',
    raceTitle: 'Hispanic',
  },
  {
    raceId: '8',
    race: 'Z',
    raceTitle: 'Mutually Defined',
  },
  {
    raceId: '9',
    race: 'G',
    raceTitle: 'Native American',
  },
  {
    raceId: '10',
    race: 'J',
    raceTitle: 'Native Hawaiian',
  },
  {
    raceId: '11',
    race: '8',
    raceTitle: 'Not Applicable',
  },
  {
    raceId: '12',
    race: '8',
    raceTitle: 'Not Provided',
  },
  {
    raceId: '13',
    race: 'E',
    raceTitle: 'Other Race or Ethnicity',
  },
  {
    raceId: '14',
    race: 'P',
    raceTitle: 'Pacific Islander',
  },
  {
    raceId: '15',
    race: 'D',
    raceTitle: 'Subcontinent Asian American',
  },
  {
    raceId: '16',
    race: 'O',
    raceTitle: 'White (Non-Hispanic)',
  },
];
